<template>
  <div class="dataloggerinfo">
    <div class="section">
      <div class="dataloggerHeader">
        <div @click="toDatalogger()">
          <i class="iconfont icon-fanhui1"></i>
          <span class="toStyle">{{$t('strategy.to')}}</span>
        </div>
        <span>{{$t('datalogger.paramSetting')}}</span>
      </div>
      <div class="dataloggerBody">
        <div class="settingBox">
          <div class="topic">{{$t('datalogger.getTitle')}}</div>
          <div class="name">{{$t('datalogger.getName')}}</div>
          <el-input v-model="getParamValue"></el-input>
          <div class="name">{{$t('datalogger.getVal')}}</div>
          <el-input
            class="nameValue"
            type="textarea"
            v-model="getvalue"
            readonly
          >
          </el-input>
          <div>
            <button style="margin-right: 5px" type="button" class="btn btn-dark" @click="getCopy">{{$t('datalogger.copyVal')}}</button>
            <button :disabled="buttonFlag" type="button" class="btn btn-dark" @click="getCollectorGetPar">{{$t('datalogger.huoqu')}}</button>
          </div>
        </div>
        <div class="settingBox">
          <div class="topic">{{$t('datalogger.postTitle')}}</div>
          <div class="name">{{$t('datalogger.postName')}}</div>
          <el-input v-model="postParamValue"></el-input>
          <div class="name">{{$t('datalogger.postVal')}}</div>
          <el-input
            class="nameValue"
            type="textarea"
            v-model="postvalue"
          >
          </el-input>
          <div>
            <button :disabled="buttonFlag" type="button" class="btn btn-dark" @click="getAdminCollectorSetPar">{{$t('datalogger.shezhi')}}</button>
          </div>
        </div>
        <div class="settingBox">
          <div class="topic">{{$t('datalogger.debugeTitle')}}</div>
          <div class="name1">
            <div class="topic1">{{$t('datalogger.debugeAddr')}}</div>
            <el-input placeholder="请输入设备地址" v-model="resultParamValue"></el-input>
          </div>
          <div class="name1">
            <div class="topic1">{{$t('datalogger.debugeName')}}</div>
            <el-input
              type="textarea"
              placeholder="命令类型:AA BB CC DD EE FF"
              v-model="resultvalue"
            >
            </el-input>
          </div>
          <div class="name1">
            <div class="topic1">{{$t('datalogger.debugeVal')}}</div>
            <el-input
              type="textarea"
              readonly
              v-model="resultSucc"
            >
            </el-input>
          </div>
          <div>
            <button style="margin-right: 5px" type="button" class="btn btn-dark" @click="resultCopy">{{$t('datalogger.copyVal')}}</button>
            <button style="margin-top: 4px;" type="button" class="btn btn-dark" @click="getSendCmdToDevice">{{$t('datalogger.xiafa')}}</button>
          </div>
        </div>
      </div>
      <el-table :disabled="buttonFlag" :data="dataloggerinfo" border stripe height="100%" :row-style="{ height: 0 }" :cell-style="{ padding: 0 }"
        :header-cell-style="{ background: 'rgb(65, 80, 90)', color: '#ffffff' }" v-loading="loadingDatalogger"
        element-loading-spinner="el-icon-loading" class="tablemain tableloding">
        <el-table-column
        :label="this.$t('settingalarm.list')"
          fixed
          type="index"
          width="70">
        </el-table-column>
        <el-table-column min-width="140px;"  :show-overflow-tooltip="true"
          :label="this.$t('datalogger.paramName')">
          <template slot-scope="scope">
            <span :title="scope.row.name">{{scope.row.name }}</span>
          </template>
        </el-table-column>
        <el-table-column min-width="140px;" :show-overflow-tooltip="true"
          :label="this.$t('datalogger.paramPar')">
          <template slot-scope="scope">
            <span :title="scope.row.par">{{scope.row.par ||"--"}}</span>
          </template>
        </el-table-column>
        <el-table-column min-width="140px;" :show-overflow-tooltip="true"
          :label="this.$t('datalogger.paramVal')">
          <template slot-scope="scope">
            <span :title="scope.row.val">{{scope.row.val ||"--"}}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
import textArea from "@/assets/EBUI/components/TextArea/index";
export default{
  props: {
    dataloggerListParamPN: {
      type: String,
    },
  },
  components:{
    textArea
  },
  data(){
    return{
      getParamValue:"",
      postParamValue:"",
      resultParamValue:"",
      getvalue:"",
      postvalue:"",
      resultvalue:"",
      resultSucc:"",
      setvalue:"",
      devaddr:"",
      dataloggerinfo:[],
      loadingDatalogger:false,
      buttonFlag:false,
    };
  },
  created(){
    this.getCollectorQueryPars()
  },
  methods:{
    //复制功能
    getCopy () {
      if(!this.getvalue){
        this.$message.error(this.$t("device.copy_val_no"))
        return false
      }
      //创建input标签
      var input = document.createElement('input')
      //将input的值设置为需要复制的内容
      input.value = this.getvalue;
      //添加input标签
      document.body.appendChild(input)
      //选中input标签
      input.select()
      //执行复制
      document.execCommand('copy')
      //成功提示信息
      this.$message.success(this.$t("datalogger.copy"))
      //移除input标签
      document.body.removeChild(input)
    },
    resultCopy () {
      if(!this.resultSucc){
        this.$message.error(this.$t("device.copy_val_no"))
        return false
      }
      //创建input标签
      var input = document.createElement('input')
      //将input的值设置为需要复制的内容
      input.value = this.resultSucc;
      //添加input标签
      document.body.appendChild(input)
      //选中input标签
      input.select()
      //执行复制
      document.execCommand('copy')
      //成功提示信息
      this.$message.success(this.$t("datalogger.copy"))
      //移除input标签
      document.body.removeChild(input)
    },
    // 获取数采器参数信息
    getCollectorQueryPars(){
      this.loadingDatalogger=true
      let param={
        pn:this.dataloggerListParamPN,
        i18n: this.$lang.currentLang,
      }
      this.$request.get("collectorQueryPars",param).then(res=>{
        this.loadingDatalogger=false
        if (res.err==0) {
          this.dataloggerinfo=res.dat
        }else{
          this.dataloggerinfo = [];
        }
      }).catch((err)=>{
        this.loadingDatalogger=false
        this.accountList = [];
      })
    },
    // 单个参数查询
    getCollectorGetPar(){
      if (this.getParamValue=='') {
        return this.$message.error( this.$t("errCode.7"));
      }
      this.buttonFlag=true
      let param={
        pn:this.dataloggerListParamPN,
        i18n: this.$lang.currentLang,
        par:this.getParamValue,
        mark:"0"
      }
      this.$request.get("collectorGetPar",param).then(res=>{
        this.buttonFlag=false
        if (res.err==0) {
          this.getvalue=res.dat.val
          this.$message.success(this.$t("datalogger.getSucc"));
          this.getCollectorQueryPars()
        }else{
          this.$message.error( this.$t(`errCode.${res.err}`));
        }
      })
    },
    // 参数修改
    getAdminCollectorSetPar(){
      if (this.postParamValue==''|| this.postvalue=='') {
        return this.$message.error( this.$t("errCode.7"));
      }
      this.buttonFlag=true
      let param={
        pn:this.dataloggerListParamPN,
        i18n: this.$lang.currentLang,
        par:this.postParamValue,
        val:this.postvalue,
        mark:"0"
      }
      this.$request.get("adminCollectorSetPar",param).then(res=>{
        this.buttonFlag=false
        if (res.err==0) {
          this.$message.success(this.$t("datalogger.postSucc"));
          this.postvalue=""
          this.postParamValue=""
          this.getCollectorQueryPars()
        }else{
          this.$message.error( this.$t(`errCode.${res.err}`));
        }
      })
    },
    // 下发指令
    getSendCmdToDevice(){
      if (this.resultParamValue==''|| this.resultvalue=='') {
        return this.$message.error( this.$t("errCode.7"));
      }
      this.buttonFlag=true
      let param={
        pn:this.dataloggerListParamPN,
        i18n: this.$lang.currentLang,
        devaddr:this.resultParamValue,
        cmd:this.resultvalue,
        mark:"0"
      }
      this.$request.get("sendCmdToDevice",param).then(res=>{
        this.buttonFlag=false
        if (res.err==0) {
          this.resultSucc=res.dat.dat
          this.$message.success(this.$t("datalogger.debugeSucc"));
        }else{
          this.$message.error( this.$t(`errCode.${res.err}`));
        }
      })
    },
    // 返回
    toDatalogger(){
      this.$emit('noticeDataloggerBox', 1);
    },
  }
}
  
</script>
<style lang="less" scoped>
@import url("../../../../assets/css/mixin.less");
.dataloggerinfo{
  display: flex;
  flex: 1;
  flex-direction: column;
  overflow: auto;
  margin: 20px;
  .btn {
    height: 32px;
    padding: 6px 12px;
    border-radius: 6px;
    font-size: 14px;
    cursor: pointer;
  }

  .btn-dark {
    background: @primaryTextColor;
    color: #fff;
    border: none;
  }
  .button {
    height: 48px;
    line-height: 48px;
    padding: 0 25px;
    margin-top: 0px;
    color: @primaryTextColor;
    background: transparent;
    border: none;
  }

  .btn-light {
    background: transparent;
    color: @primaryTextColor;
    border: 1px solid @primaryTextColor;
  }
  /deep/.el-textarea__inner,.el-input__inner{
    background: #2b3842;
    color: #fff;
    border: 1px solid #A3A9B5;
  }
  /deep/.el-textarea__inner,.el-input__inner:focus{
    border: 1px solid #A3A9B5 !important;
  }
  /deep/.el-input .el-input__inner {
    background-color: #2b3842;
    border: 1px solid #A3A9B5;
    color:#fff;
  }
  .section{
    flex: 1;
    display: flex;
    border-radius: 0px;
    border: none;
    flex-direction: column;
    background: rgb(34, 45, 53);
    padding: 0px;
    overflow: auto;
    .dataloggerHeader{
      display: flex;
      padding: 0 0 15px 0;
      font-size: 20px;
      color: #ffffff;
      align-items: center;
      background-color: #2D3F4B;
      i{
        font-size: 26px;
      }
      div:hover{
          cursor: pointer;
      }
      .toStyle{
        margin: 0 20px 0 5px;
      }
    }
    .dataloggerBody{
      display: flex;
      justify-content: space-around;
      align-items: center;
      color: #fff;
      padding-bottom: 10px;
      .settingBox{
        width: 30%;
        div:last-child{
          text-align: right;
        }
        .name1{
          display: flex;
          justify-content: space-around;
          align-items: center;
          padding-top: 10px;
        }
        .topic1{
          width: 90px;
          text-align:right
        }
        .topic{
          font-size: 20px;
          padding-top: 16px;
        }
        .name{
          padding: 10px 0;
        }
        .nameValue{
          padding-bottom: 10px;
        }
      }
      
    }
    .tableloding {

    // 加载数据时遮罩
    /deep/.el-loading-mask {
      background-color: rgb(34, 45, 53, .5);
    }

    /deep/.el-loading-spinner i {
      color: @primaryTextColor;
    }
    }

    .tablemain {
    border: none;
    background-color: rgb(34, 45, 53);

    .operation i {
      color: @primaryTextColor;
    }

    /deep/.el-table__header th {
      height: 48px;
    }

    /deep/.el-table__header th.is-leaf {
      border-color: rgba(198, 209, 221, 0.5);
      // border-bottom: none;
    }

    /deep/.el-table__header th>.cell {
      font-weight: normal;
      font-size: 12px;
    }

    /deep/.el-table__body tr,
    /deep/.el-table__body td {
      background-color: rgb(34, 45, 53);
      color: #ffffff;
      border-color: rgba(198, 209, 221, 0.5);
    }

    /deep/.el-table__body td.el-table-column--selection {
      background-color: rgb(65, 80, 90);
      color: #ffffff;
    }

    /deep/.el-table__body .cell.el-tooltip {
      font-size: 14px;
    }

    /deep/.el-table__fixed-right::before,
    /deep/.el-table__fixed::before {
      display: none;
    }

    ::-webkit-scrollbar {
      width: 6px;
      height: 6px;
      background-color: #222d35;
    }

    // 关于头部右侧空白
    /deep/.el-table__fixed-right-patch {
      background-color: rgb(65, 80, 90);
      border-bottom: none;
    }

    /deep/th.gutter {
      background-color: rgb(65, 80, 90);
    }
    }
  }
}
</style>